export const getClientStyle = state => state.loadClientStyleReducer;
